import { render } from "./editDoubleSaleArticleGuid.vue?vue&type=template&id=7bbc44a6&scoped=true&ts=true"
import script from "./editDoubleSaleArticleGuid.vue?vue&type=script&lang=ts"
export * from "./editDoubleSaleArticleGuid.vue?vue&type=script&lang=ts"

import "./editDoubleSaleArticleGuid.vue?vue&type=style&index=0&id=7bbc44a6&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbc44a6"]])

export default __exports__